<div class="cell auto grid-y cell-block-y blockContent" *ngIf="study">
    <table>
        <thead>
        <tr class="_titlePartTable">
            <th></th>
            <th class="_numberColumn"[i18nKey]="'studies.ACCOUNTANT.amounts'"></th>
        </tr>
        </thead>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <tbody>
        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.dishes.turnover'"></td>
            <td class="_number">{{study.dishesTurnover | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.wines.turnover'"></td>
            <td class="_number"> {{study.winesTurnover | number:'1.2'}}</td>
        </tr>

        <tr *ngIf="study.pcg2025">
            <td [i18nKey]="'studies.profit.loss.accounts.layout.selling.income'"></td>
            <td class="_number">{{study.layoutSellingIncome | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.other.operating.products'"></td>
            <td class="_number">{{study.otherOperatingProducts | number:'1.2'}}</td>
        </tr>

        <tr>
            <td class="text-right"><b [i18nKey]="'studies.profit.loss.accounts.total.operating.products'"></b></td>
            <td class="_number"><b>{{study.totalOperatingProducts | number:'1.2'}}</b></td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.ingredients.purchase.costs'"></td>
            <td class="_number">{{study.ingredientsPurchaseCosts | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.wine.bottles.purchase.costs'"></td>
            <td class="_number">{{study.wineBottlesPurchaseCosts | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.cellar.stock.variation'"></td>
            <td class="_number"> {{study.cellarStockVariation | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.external.loads'"></td>
            <td class="_number">{{study.externalLoads | number:'1.2'}} </td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.gross.salaries'"></td>
            <td class="_number">{{study.grossSalaries | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.severance.pay'"></td>
            <td class="_number">{{study.severancePay | number: '1.2'}}</td>
        </tr>


        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.social.charges'"></td>
            <td class="_number">{{study.socialCharges | number:'1.2'}}</td>
        </tr>

        <tr  *ngIf="study.pcg2025">
            <td [i18nKey]="'studies.profit.loss.accounts.layout.value.sold'"></td>
            <td class="_number">{{study.layoutValueSold | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.depreciation.charges'"></td>
            <td class="_number">{{study.depreciationCharges | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.other.operating.charges'"></td>
            <td class="_number">{{study.otherOperatingCharges | number: '1.2'}}</td>
        </tr>

        <tr>
            <td class="text-right"><b [i18nKey]="'studies.profit.loss.accounts.total.operating.charges'"></b></td>
            <td class="_number"><b>{{study.totalOperatingCharges | number:'1.2'}}</b></td>
        </tr>

        <tr>
            <td class="text-right _totalColumn"[i18nKey]="'studies.profit.loss.accounts.total.operating.result'"></td>
            <td class="_number _totalColumn">{{study.totalOperatingResult | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.investment.interest'"></td>
            <td class="_number">{{study.investmentInterest | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.other.financial.products'"></td>
            <td class="_number">{{study.otherFinancialProducts | number:'1.2'}}</td>
        </tr>

        <tr>
            <td class="text-right"><b [i18nKey]="'studies.profit.loss.accounts.financial.products'"></b></td>
            <td class="_number"><b>{{study.totalFinancialProducts | number:'1.2'}}</b></td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.loan.interest'"></td>
            <td class="_number">{{study.loanInterest | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.overdraft.charges'"></td>
            <td class="_number">{{study.overdraftCharges | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.other.financial.charges'"></td>
            <td class="_number">{{study.otherFinancialCharges | number:'1.2'}}</td>
        </tr>

        <tr>
            <td class="text-right"><b [i18nKey]="'studies.profit.loss.accounts.financial.charges'"></b></td>
            <td class="_number"><b>{{study.totalFinancialCharges | number:'1.2'}}</b></td>
        </tr>

        <tr>
            <td class="text-right _totalColumn"[i18nKey]="'studies.profit.loss.accounts.continuing.operations.result'"></td>
            <td class="_number _totalColumn">{{study.financialResult | number:'1.2'}}</td>
        </tr>

        <tr  *ngIf="!study.pcg2025">
            <td [i18nKey]="'studies.profit.loss.accounts.layout.selling.income'"></td>
            <td class="_number">{{study.layoutSellingIncome | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.other.exceptional.incomes'"></td>
            <td class="_number">{{study.otherExceptionalIncomes | number:'1.2'}}</td>
        </tr>

        <tr *ngIf="!study.pcg2025">
            <td class="text-right"><b [i18nKey]="'studies.profit.loss.accounts.exceptional.income'"></b></td>
            <td class="_number"><b>{{study.totalExceptionalIncome | number:'1.2'}}</b></td>
        </tr>

        <tr  *ngIf="!study.pcg2025">
            <td [i18nKey]="'studies.profit.loss.accounts.layout.value.sold'"></td>
            <td class="_number">{{study.layoutValueSold | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.other.non.recurring.charges'"></td>
            <td class="_number">{{study.otherNonRecurringCharges | number:'1.2'}}</td>
        </tr>

        <tr *ngIf="!study.pcg2025">
            <td class="text-right"><b [i18nKey]="'studies.profit.loss.accounts.non.recurring.charges'"></b></td>
            <td class="_number"><b>{{study.totalNonRecurringCharges | number:'1.2'}}</b></td>
        </tr>

        <tr>
            <td class="text-right _totalColumn"[i18nKey]="'studies.profit.loss.accounts.exceptional.result'"></td>
            <td class="_number _totalColumn">{{study.exceptionalResult | number:'1.2'}}</td>
        </tr>

        <tr>
            <td class="text-right _totalColumn"[i18nKey]="'studies.profit.loss.accounts.net.pre.tax.result'"></td>
            <td class="_number _totalColumn">{{study.netPreTaxResult | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.profit.loss.accounts.income.tax'"></td>
            <td class="_number">{{study.incomeTax | number:'1.2'}}</td>
        </tr>

        <tr>
            <td class="text-right _totalColumn"[i18nKey]="'studies.profit.loss.accounts.net.result'"></td>
            <td class="_number _totalColumn">{{study.netResult | number:'1.2'}}</td>
        </tr>
        </tbody>
    </table>
</div>
